var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34783 0C1.94696 0 0 1.90296 0 4.24959C0 6.59621 1.94696 8.49917 4.34783 8.49917H7.82609V6.79934H4.34783C2.90696 6.79934 1.73913 5.6579 1.73913 4.24959C1.73913 2.84127 2.90696 1.69983 4.34783 1.69983H7.82609V0H4.34783ZM11.3043 0V1.69983H14.7826C16.2235 1.69983 17.3913 2.84127 17.3913 4.24959C17.3913 5.6579 16.2235 6.79934 14.7826 6.79934H11.3043V8.49917H14.7826C17.1835 8.49917 19.1304 6.59621 19.1304 4.24959C19.1304 1.90296 17.1835 0 14.7826 0H11.3043ZM5.21739 3.39967V5.0995H13.913V3.39967H5.21739ZM14.2731 10.199L13.0435 11.4008L15.2921 13.5987L13.0418 15.7982L14.2714 17L16.5217 14.8005L18.7704 16.9983L20 15.7965L17.7514 13.5987L19.9253 11.4739L18.6957 10.272L16.5217 12.3968L14.2731 10.199Z",
    fill: "#A1AAB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlink);
export default __webpack_public_path__ + "static/media/unlink.97f28c5b.svg";
export { ForwardRef as ReactComponent };